import React, { useCallback, useState } from 'react'
import { pdfjs, Document, Page } from 'react-pdf'
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';
import styles from 'css/components/lesson-builder/presentation-slide.module.css';

export const PresentationSlide = ({ lessonPdf, pageNumber, isCurrent, className = '', resizeKey = '', width = 540, containerWidth = undefined, containerHeight = undefined, videoLinks = [] }) => {
	pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`

	const [scale, setScale] = useState(1)
	const RENDER_WIDTH = 1200

	const onPageRenderSuccess = useCallback(() => {
		if (!containerWidth || !containerHeight) return
		// After the page renders, measure the actual canvas and calculate scale
		// to fit within the container
		const canvas = document.querySelector(`.${styles.presentMode} canvas`)
		if (!canvas) return
		const canvasWidth = canvas.width / (window.devicePixelRatio || 1)
		const canvasHeight = canvas.height / (window.devicePixelRatio || 1)
		const scaleX = containerWidth / canvasWidth
		const scaleY = containerHeight / canvasHeight
		setScale(Math.min(scaleX, scaleY) * 0.95)
	}, [containerWidth, containerHeight])

	// Present mode: render at high resolution, CSS-scale to fit container
	if (containerWidth && containerHeight) {
		return (
			<div
				className={`${styles.presentMode} presentation-slide ${isCurrent ? 'current' : ''} ${className}`}
				style={{ width: containerWidth, height: containerHeight }}
			>
				<div style={{ transform: `scale(${scale})`, transformOrigin: 'center center' }}>
					<Document file={lessonPdf}>
						<Page
							pageNumber={pageNumber}
							width={RENDER_WIDTH}
							canvasBackground="transparent"
							renderTextLayer={false}
							onRenderSuccess={onPageRenderSuccess}
						/>
					</Document>
				</div>
				{videoLinks.length > 0 && (
					<div className={styles.videoLinks}>
						{videoLinks.map((link, i) => (
							<a
								key={link.url + i}
								className={styles.videoLinkButton}
								href={link.url}
								target="_blank"
								rel="noopener noreferrer"
								title={link.title || 'Watch video'}
							>
								<span className={styles.videoLinkIcon} aria-hidden="true">▶</span>
								{link.title ? (link.title.length > 40 ? link.title.slice(0, 37) + '…' : link.title) : 'Watch video'}
							</a>
						))}
					</div>
				)}
			</div>
		)
	}

	// Lesson builder / sidebar mode: fixed width, normal rendering
	return (
		<div
			className={`${styles.presentationSlide} presentation-slide ${isCurrent ? 'current' : ''} ${className}`}
		>
			<Document file={lessonPdf}>
				<Page pageNumber={pageNumber} width={width} canvasBackground="transparent"/>
			</Document>
		</div>
	)
}
